
export type SignResult = {
  publicKeyMultibase: String,
  signatures: [],
};